// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_open_now = /** @type {(inputs: {}) => string} */ () => {
	return `Open now`
};

const el_open_now = /** @type {(inputs: {}) => string} */ () => {
	return `Ανοιχτά`
};

const ru_open_now = /** @type {(inputs: {}) => string} */ () => {
	return `Открыто`
};

const he_open_now = /** @type {(inputs: {}) => string} */ () => {
	return `פתוח עכשיו`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const open_now = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.open_now(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("open_now", locale)
	if (locale === "en") return en_open_now(inputs)
	if (locale === "el") return el_open_now(inputs)
	if (locale === "ru") return ru_open_now(inputs)
	if (locale === "he") return he_open_now(inputs)
	return "open_now"
};